module.exports = __webpack_public_path__ + "static/img/web3wallet.bf099a4d.svg";